// Optimized animation configurations for better performance
export const smoothAnimations = {
  // Reduced motion variants for better performance
  fadeIn: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { 
      duration: 0.4,
      ease: [0.25, 0.46, 0.45, 0.94] // Custom easing for smoothness
    }
  },

  fadeInUp: {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    transition: { 
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  },

  fadeInScale: {
    initial: { opacity: 0, scale: 0.95 },
    animate: { opacity: 1, scale: 1 },
    transition: { 
      duration: 0.4,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  },

  // Stagger animations with reduced timing
  staggerContainer: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1, // Reduced from 0.2
        delayChildren: 0.1
      }
    }
  },

  staggerItem: {
    hidden: { opacity: 0, y: 15 }, // Reduced from y: 50
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.4, // Reduced from 0.6
        ease: [0.25, 0.46, 0.45, 0.94]
      }
    }
  },

  // Hover animations with will-change for performance
  hoverScale: {
    whileHover: { 
      scale: 1.02,
      transition: { 
        duration: 0.2,
        ease: "easeOut"
      }
    },
    whileTap: { 
      scale: 0.98,
      transition: { 
        duration: 0.1,
        ease: "easeOut"
      }
    }
  },

  // Card hover with optimized transforms
  cardHover: {
    whileHover: { 
      y: -2,
      boxShadow: "0 10px 25px rgba(0,0,0,0.1)",
      transition: { 
        duration: 0.2,
        ease: "easeOut"
      }
    }
  },

  // Mobile-optimized animations (less intensive)
  mobileOptimized: {
    initial: { opacity: 0 },
    animate: { opacity: 1 },
    transition: { 
      duration: 0.3,
      ease: "easeOut"
    }
  }
}

// Performance optimization utility
export const getOptimizedAnimation = (animationType, isMobile = false) => {
  if (isMobile) {
    return smoothAnimations.mobileOptimized
  }
  return smoothAnimations[animationType] || smoothAnimations.fadeIn
}

// Viewport configuration for better performance
export const optimizedViewport = {
  once: true,
  margin: "-50px",
  amount: 0.3
}

// Global animation settings
export const globalAnimationSettings = {
  // Reduce motion for accessibility
  reduceMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches,
  
  // Mobile detection
  isMobile: window.innerWidth < 768,
  
  // Performance mode based on device
  performanceMode: navigator.hardwareConcurrency < 4 || window.innerWidth < 768
}
